import "./App.css";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import backend from 'i18next-http-backend';
import ApplicationService from "./services/application/ApplicationService";
import { wait } from "@testing-library/user-event/dist/utils";

const setupI18n = async () => {
    // Set up i18n here, potentially returning a promise if it's async
    // This may include configuring a backend to load translations using Axios
    await i18n
        .use(LanguageDetector)
        .use(backend)
        .use(initReactI18next)
        .init({
            backend: backendOptions,
            fallbackLng: {
                'default': ['en']
            },
            debug: false,
            load:"languageOnly",
            ns: ["translations"],
            defaultNS: "translations",
            keySeparator: false,
            interpolation: {
                escapeValue: false,
                formatSeparator: ","
            },
            react: {
                useSuspense: false,
            },
        });
};

const loadResources = async(locale:string)=> {
  return await ApplicationService.getTranslations(locale)
    .then((response) => { return response.data })
    .catch((error) => { console.log(error); }); 
}

const backendOptions = {
  loadPath: '{{lng}}|{{ns}}', 
  request: (options:any, url:any, payload:any, callback:any) => {
    try {
      const fetchedItem = localStorage.getItem("reduxState");
      const persistedState = localStorage.getItem("reduxState")
      ? JSON.parse(fetchedItem !== null ? fetchedItem : "")
      : {};

      if (!persistedState?.profile?.accessToken) {
          callback(null, {
              status: 500,
          });
      }
      
      const [lng] = url.split('|');
      loadResources(lng).then((response) => {
        callback(null, {
          data: response,
          status: 200, 
        });
      });
    } catch (e) {
      console.error(e);
      callback(null, {
        status: 500,
      });
    }
  },
};

export default setupI18n;